import { ReactElement } from 'react';
import Header from '../header';

import styles from './page.module.scss';
import { PageProps } from './page.interfaces';

const Page = (props: PageProps): ReactElement => {
  const { children, showHeaderMainNav = true } = props;

  return (
    <div className={styles.page}>
      <Header showMainNav={showHeaderMainNav} />
      <div className={styles.body}>{children}</div>
    </div>
  );
};
export default Page;
